import React from 'react';
import { Link } from 'react-router-dom';

const Farmers: React.FC = () => {
  // Sample farmers data - will be replaced with API call
  const farmers = [
    {
      id: '1',
      name: 'John Kamau',
      location: 'Nairobi County',
      products: ['Maize', 'Beans', 'Vegetables'],
      rating: 4.8,
      verified: true,
      image: '👨‍🌾',
    },
    {
      id: '2',
      name: 'Mary Wanjiru',
      location: 'Kiambu County',
      products: ['Tomatoes', 'Kale', 'Cabbage'],
      rating: 4.9,
      verified: true,
      image: '👩‍🌾',
    },
    {
      id: '3',
      name: 'Peter Ochieng',
      location: 'Nakuru County',
      products: ['Potatoes', 'Carrots', 'Onions'],
      rating: 4.7,
      verified: true,
      image: '👨‍🌾',
    },
    {
      id: '4',
      name: 'Grace Njeri',
      location: 'Meru County',
      products: ['Coffee', 'Tea', 'Bananas'],
      rating: 5.0,
      verified: true,
      image: '👩‍🌾',
    },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 via-white to-green-100">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-green-600 to-green-800 text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-5xl font-bold mb-4">
              Meet Our Farmers
            </h1>
            <p className="text-xl text-green-100 max-w-2xl mx-auto">
              Connect directly with verified farmers across Kenya. Fresh produce, fair prices, transparent supply chain.
            </p>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-12 bg-white shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="text-4xl font-bold text-green-600 mb-2">500+</div>
              <div className="text-gray-600">Verified Farmers</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-green-600 mb-2">47</div>
              <div className="text-gray-600">Counties Covered</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-green-600 mb-2">98%</div>
              <div className="text-gray-600">Satisfaction Rate</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-green-600 mb-2">24/7</div>
              <div className="text-gray-600">Support Available</div>
            </div>
          </div>
        </div>
      </section>

      {/* Farmers Grid */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Search and Filter */}
          <div className="mb-12">
            <div className="flex flex-col md:flex-row gap-4">
              <div className="flex-1">
                <input
                  type="text"
                  placeholder="Search farmers by name or location..."
                  className="w-full px-6 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-green-500"
                />
              </div>
              <select className="px-6 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-green-500">
                <option>All Counties</option>
                <option>Nairobi</option>
                <option>Kiambu</option>
                <option>Nakuru</option>
                <option>Meru</option>
              </select>
              <select className="px-6 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-green-500">
                <option>All Products</option>
                <option>Vegetables</option>
                <option>Fruits</option>
                <option>Grains</option>
                <option>Dairy</option>
              </select>
            </div>
          </div>

          {/* Farmers Cards */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {farmers.map((farmer) => (
              <div
                key={farmer.id}
                className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1 overflow-hidden"
              >
                {/* Card Header */}
                <div className="bg-gradient-to-r from-green-600 to-green-800 p-6 text-center relative">
                  <div className="text-6xl mb-3">{farmer.image}</div>
                  {farmer.verified && (
                    <div className="absolute top-2 right-2 bg-white rounded-full p-1">
                      <svg className="w-5 h-5 text-green-600" fill="currentColor" viewBox="0 0 20 20">
                        <path
                          fillRule="evenodd"
                          d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </div>
                  )}
                  <h3 className="text-xl font-bold text-white">{farmer.name}</h3>
                  <p className="text-green-100 text-sm mt-1">{farmer.location}</p>
                </div>

                {/* Card Body */}
                <div className="p-6">
                  {/* Rating */}
                  <div className="flex items-center justify-center mb-4">
                    <span className="text-yellow-400 text-lg mr-1">★</span>
                    <span className="font-semibold text-gray-900">{farmer.rating}</span>
                    <span className="text-gray-500 text-sm ml-1">(50+ reviews)</span>
                  </div>

                  {/* Products */}
                  <div className="mb-4">
                    <h4 className="text-sm font-semibold text-gray-700 mb-2">Products:</h4>
                    <div className="flex flex-wrap gap-2">
                      {farmer.products.map((product, idx) => (
                        <span
                          key={idx}
                          className="px-3 py-1 bg-green-50 text-green-700 text-xs rounded-full"
                        >
                          {product}
                        </span>
                      ))}
                    </div>
                  </div>

                  {/* Actions */}
                  <div className="space-y-2">
                    <Link
                      to={`/products?farmer=${farmer.id}`}
                      className="block w-full py-2 px-4 bg-gradient-to-r from-green-600 to-green-800 text-white rounded-xl text-center font-medium hover:from-green-700 hover:to-green-900 transition-all transform hover:scale-105"
                    >
                      View Products
                    </Link>
                    <button className="w-full py-2 px-4 border border-green-600 text-green-600 rounded-xl font-medium hover:bg-green-50 transition-all">
                      Contact Farmer
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Become a Farmer CTA */}
          <div className="mt-16 bg-gradient-to-r from-green-600 to-green-800 rounded-2xl shadow-xl p-8 text-center text-white">
            <h3 className="text-3xl font-bold mb-4">Are you a farmer?</h3>
            <p className="text-xl text-green-100 mb-6 max-w-2xl mx-auto">
              Join AgriMarket today and connect directly with thousands of buyers across Kenya. No middlemen, better prices, transparent transactions.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/register"
                className="px-8 py-4 bg-white text-green-600 rounded-xl font-bold hover:bg-green-50 transition-all transform hover:scale-105 shadow-lg"
              >
                Register as Farmer
              </Link>
              <Link
                to="/about"
                className="px-8 py-4 border-2 border-white text-white rounded-xl font-bold hover:bg-white hover:text-green-600 transition-all"
              >
                Learn More
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Farmers;

